import { connect } from 'react-redux';
import { getData as getWallet } from '../../modules/wallet/selectors';
import Intercom from '../../components/Intercom/Intercom';
const mapState = (state, ownProps) => {
    const wallet = getWallet(state);
    const enhancedData = {};
    if (wallet?.address) {
        enhancedData['Wallet'] = wallet?.address.toLowerCase() ?? null;
    }
    if (wallet?.providerType) {
        enhancedData['Wallet type'] = wallet?.providerType ?? null;
    }
    return {
        data: {
            ...enhancedData,
            ...ownProps.data
        }
    };
};
export default connect(mapState)(Intercom);
//# sourceMappingURL=EnhancedIntercom.container.js.map